import { http } from "@/lib/http";
export function fetchVideos() {
  return http.get("/api/videos/get_all").then((res) => res.data);
}
export function fetchVideo(id) {
  return fetchVideos().then((list) => list.find((v) => v._id === id) ?? null);
}
export function addVideo(payload) {
  return http.post("/api/videos/add", payload).then((res) => res.data);
}
export function editVideo(id, payload) {
  return http.post(`/api/videos/edit/${id}`, payload).then((res) => res.data);
}
export function deleteVideo(id) {
  return http.delete(`/api/videos/delete/${id}`).then((res) => res.data);
}
